<template>
    <div class="row d-flex justify-content-center mt-5">
   
        <div class=" ">
            Received Data: 
            {{received_data}}
        </div>
    </div>
</template>

<script>
    
    import { Encrypter } from 'laravel-crypton';
    const key = 'OY5c7fhSwaW+5MseQMBoPbEpGYoy4m+y4mIt8JoG+vA=';
    //const key = 'OY5c7fhSwaW+64646+y4mIt8JoG+vA=';
    const crypt = new Encrypter(key);

    export default{

        
        mounted() {
            //console.log('Bank info started..');   
            //console.log(this.employee_id);  
        },
        props: [],
        data(){            
            
            return {
                
                successmsg:'',
                errormsg:[],
                fdata: {email: null, password:null },

                form_file : null,

                received_data : null,
                
            }
        },
        methods:{
            
            
            receveData:function()
            {
                
                var qs = window.location.search;
                qs = qs.replace("?", ''); // remove the ?

                


                axios.get(this.$api_url+'/encrypt?'+qs)
                    .then(function (response) {
                            
                        console.log(response.data);
                        this.received_data = crypt.decrypt(response.data);
                        console.log(crypt.decrypt(response.data));

                    }.bind(this));
            },
            
            
            

        },
        created: function(){
            this.receveData();
            
        },
        computed: 
        {
            
        }
    }
</script>